import React from 'react';

import { AuthProvider } from './auth/AuthContext';

const AppProvider = ({ children }) => <AuthProvider>{children}</AuthProvider>;

export default AppProvider;
